import { Location } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ROUTING_CAMBIO_VIA_PAGO_PENSION } from "@constants/url.constant";
import { StepStatus } from "@enums/step-status.enum";
import { IStep } from "@interfaces/step.interface";
import { ModalService } from "@services/modal/modal.service";
import { StepsService } from "@services/steps/steps.service";
import { Subscription } from 'rxjs';

@Component({
    selector: "app-cambio-via-pago",
    templateUrl: "./cambio-via-pago.component.html",
    styleUrls: ["./cambio-via-pago.component.scss"],
    standalone: false
})
export class CambioViaPagoComponent implements OnInit, OnDestroy {
  public STEPS: IStep[] = [
    {
      status: StepStatus.Pending,
      title: "Datos Personales",
      path: ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_DATOS_PERSONALES,
      sessionStorage: "step_1",
    },
    {
      status: StepStatus.Pending,
      title: "Datos Bancarios",
      path: ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_DATOS_BANCARIOS,
      sessionStorage: "step_2",
    },
    {
      status: StepStatus.Pending,
      title: "Confirmar",
      path: ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_CONFIRMAR,
      sessionStorage: "step_3",
    },
  ];
  public currentStep: number = 0;
  showStepper: boolean = true;
  subs = new Subscription();

  constructor(
    private readonly location: Location,
    private readonly stepsService: StepsService,
    private readonly modalService: ModalService,
  ) {
    stepsService.steps = this.STEPS;
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.subs.add(
      this.stepsService.showStepper.subscribe(value => {
        this.showStepper = value;
      })
    );
  }

  async goBack() {
    this.stepsService.actualStep === 1
      ? await this.modalService.cambioViaPagoExitModal()
      : this.location.back();
  }
}
